import { Bone } from '../primitives';

// Matches the onboarding steps (OnboardingWork.js / OnboardingAudio.js): progress bar,
// heading, a flex-wrap of tag pills, and a text input.
export default function OnboardingSkeleton() {
    return (
        <div className="container" style={{ maxWidth: 560, paddingTop: 40 }}>
            <Bone h={6} w="100%" r={999} style={{ marginBottom: 24 }} />
            <Bone h={24} w="70%" style={{ marginBottom: 24 }} />
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 20 }}>
                {Array.from({ length: 8 }).map((_, i) => (
                    <Bone key={i} h={36} w={90 + (i % 3) * 20} r={999} />
                ))}
            </div>
            <Bone h={40} w="100%" style={{ marginBottom: 20 }} />
            <Bone h={44} w={140} r={9} />
        </div>
    );
}
